import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { DelimitedTextCopySource } from 'app/model/pipeline/copysource/delimitedtext.source';
import {
    convertStoreSettingsToResource,
    convertStoreSettingsToModel
} from './store-read-settings/store-read-settings.util';
import {
    convertFormatSettingsToResource,
    convertFormatSettingsToModel
} from './format-read-settings/format-read-settings.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DelimitedTextCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class DelimitedTextCopySourceAdapter extends CopySourceAdapter<
    DelimitedTextCopySource,
    Model.DelimitedTextSource
> {
    protected override async _toResource(copySource: DelimitedTextCopySource): Promise<Model.DelimitedTextSource> {
        const result: Model.DelimitedTextSource = this.getCommonCopySourceProperties(copySource, 'DelimitedTextSource');

        await convertStoreSettingsToResource(copySource.storeSettings, result, this.context);
        await convertFormatSettingsToResource(copySource.formatSettings, result, this.context);

        return result;
    }

    protected override async _toModel(
        source: Model.DelimitedTextSource,
        copyActivity: CopyActivity
    ): Promise<DelimitedTextCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            DelimitedTextCopySource.MODEL,
            source,
            copyActivity
        ) as DelimitedTextCopySource;

        await convertStoreSettingsToModel(source.storeSettings, result, this.context);
        await convertFormatSettingsToModel(source.formatSettings, result, this.context);
        return result;
    }
}
